import React from 'react';
import filter from 'lodash/filter';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import {withData} from '../../containers/DataContainer';
import {getTotalValue, getTotalDistance, toPriceStr} from '../../components/Cards/utils';

const Stats = withData(({
  meta,
  data,
  dateData,
  setPath
}) => {

  const {deliveries} = data;

  const getVehicleData = data => filter(data,
    {vehicleId: meta._id}
  );
  const vehicleDeliveries = getVehicleData(deliveries);

  const totalValue = getTotalValue(vehicleDeliveries);
  const totalDistance = getTotalDistance(vehicleDeliveries);
  const valuePerDistance = totalValue && totalDistance ? totalValue / totalDistance : 0;

  return <Grid container>
    <Grid item xs={12} sm={6}>
      <StatField title='Placa' body={
        meta._id
        }
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <StatField title='Caçambas' body={
        meta.slotNumber
        }
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <StatField title='Final' body={
        meta.finalSlot ? 'Sim' : 'Não'
        }
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <StatField title='Valor' body={
        toPriceStr(totalValue)
        }
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <StatField title='Distância' body={
        `${totalDistance} Km`}/>
    </Grid>
    <Grid item xs={12} sm={6}>
      <StatField title='R$ / Km' body={
        `${valuePerDistance.toFixed(2)}`
        }
      />
    </Grid>
  </Grid>;
});

Stats.defaultProps = {
  meta: {
    _id: undefined,
    slotNumber: undefined,
    finalSlot: undefined
  }
};

const StatField = ({title, body}) =>
  <Grid container spacing={2}>
    <Grid item>
      <Typography variant='root'>
        {title}:
      </Typography>
    </Grid>
    <Grid item>
      <Typography variant='root'>
        {body}
      </Typography>
    </Grid>
  </Grid>;

export default Stats;
